import api from "./api";

export const apiversion = {
  getVersion: async () => {
    try {
      const response = await api.get("/version");
      return response.data.version;
    } catch (error) {
      console.error(
        "Error fetching version:",
        error.response?.data || error.message
      );
      return "Unknown"; // Fallback in case of an error
    }
  },
};

export default apiversion;
